import styled from 'styled-components'

export const SpinnerWrapper = styled.div<{ $overlay?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  ${({ $overlay }) =>
    $overlay &&
    `
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 3;
  `}
  svg {
    stroke: ${({ theme }) => theme.colors.violet};
  }
`
